import { useState } from 'react';
import { useCart } from '../../../context/CartContext';

import { Order } from '../../../types';
import OrderList from './OrderList';
import OrderDetailsModal from './OrderDetailsModal';

export default function OrdersTab() {
  const { orders, fetchOrders, updateOrderStatus, loading, error } = useCart();
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleActionClick = async (orderId: number, action: string) => {
    const order = orders.find((o) => o.id === orderId);
    if (!order) return;

    try {
      switch (action) {
        case 'View Details':
          setSelectedOrder(order);
          setIsModalOpen(true);
          break;
        case 'Confirm Order':
          await updateOrderStatus(orderId, 'confirmed');
          break;
        case 'Mark as Processing':
          await updateOrderStatus(orderId, 'processing');
          break;
        case 'Mark as Shipped':
          await updateOrderStatus(orderId, 'shipped');
          break;
        case 'Mark as Delivered':
          await updateOrderStatus(orderId, 'delivered');
          break;
        default:
          console.warn(`Unhandled action: ${action}`);
      }
    } catch (err) {
      // Error is handled in CartContext
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-semibold mb-6">Orders</h2>
      <OrderList
        orders={orders}
        loading={loading}
        error={error}
        onActionClick={handleActionClick}
      />
      <OrderDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        orderId={selectedOrder?.id || null}
      />
    </div>
  );
}